import React, { useEffect, useState } from "react";

import Swal from "sweetalert2";

import {
    FaUsers,
    FaFileAlt,
    FaBook,
    FaClipboardList
} from "react-icons/fa";

import API_BASE_URL from "../config/api";


function Dashboard() {

    const API_URL = API_BASE_URL.replace(/\/$/, "");

    const [dashboard, setDashboard] = useState({
        total_users: 0,
        total_papers: 0,
        total_subjects: 0
    });

    const [loading, setLoading] = useState(true);


    // =========================================================
    // GET DASHBOARD DATA
    // =========================================================

    const fetchDashboard = async () => {

        try {

            setLoading(true);

            const response = await fetch(
                `${API_URL}/admin/dashboard`,
                {
                    method: "GET",
                    credentials: "include",
                    headers: {
                        Accept: "application/json"
                    }
                }
            );

            const result = await response.json();

            if (!response.ok) {
                throw new Error(
                    result.message || "Unable to load dashboard"
                );
            }

            if (result.success) {

                setDashboard({
                    total_users: result.data.total_users || 0,
                    total_papers: result.data.total_papers || 0,
                    total_subjects: result.data.total_subjects || 0
                });

            }

        } catch (error) {

            console.error("Dashboard Error:", error);

            Swal.fire({
                icon: "error",
                title: "Dashboard Error",
                text: error.message
            });

        } finally {

            setLoading(false);

        }
    };


    // =========================================================
    // LOAD DASHBOARD
    // =========================================================

    useEffect(() => {

        fetchDashboard();

    }, []);


    // =========================================================
    // CARD
    // =========================================================

    const DashboardCard = ({
        title,
        value,
        icon,
        iconClass
    }) => {

        return (
            <div className="col-md-4 col-lg-4 mb-4">

                <div
                    className="card border-0 shadow-sm h-100"
                    style={{
                        borderRadius: "12px"
                    }}
                >

                    <div className="card-body p-4">

                        <div className="d-flex justify-content-between align-items-center">

                            <div>

                                <h6 className="text-muted mb-2">
                                    {title}
                                </h6>

                                <h2
                                    className="fw-bold mb-0"
                                    style={{
                                        fontSize: "32px"
                                    }}
                                >
                                    {loading ? (
                                        <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                        />
                                    ) : (
                                        value
                                    )}
                                </h2>

                            </div>


                            <div
                                className={`rounded-circle d-flex align-items-center justify-content-center ${iconClass}`}
                                style={{
                                    width: "55px",
                                    height: "55px"
                                }}
                            >
                                {icon}
                            </div>

                        </div>

                    </div>

                </div>

            </div>
        );
    };


    return (

        <div>

            {/* =====================================================
                HEADER
            ===================================================== */}

            <div className="mb-4">

                <h2 className="mb-1">
                    Dashboard
                </h2>

                <p className="text-muted mb-0">
                    HomeoAdda Admin Dashboard
                </p>

            </div>


            {/* =====================================================
                CARDS
            ===================================================== */}

            <div className="row">


                {/* Total Users */}

                <DashboardCard
                    title="Total Users"
                    value={dashboard.total_users}
                    icon={
                        <FaUsers
                            size={25}
                            className="text-primary"
                        />
                    }
                    iconClass="bg-primary bg-opacity-10"
                />


                {/* Total Papers */}

                <DashboardCard
                    title="Total Papers"
                    value={dashboard.total_papers}
                    icon={
                        <FaFileAlt
                            size={25}
                            className="text-success"
                        />
                    }
                    iconClass="bg-success bg-opacity-10"
                />


                {/* Total Subjects */}

                <DashboardCard
                    title="Total Subjects"
                    value={dashboard.total_subjects}
                    icon={
                        <FaBook
                            size={25}
                            className="text-warning"
                        />
                    }
                    iconClass="bg-warning bg-opacity-10"
                />


            </div>

        </div>

    );
}


export default Dashboard;